import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const dropZoneFn = /* @__PURE__ */ createRecipe('drop-zone', {}, [])

const dropZoneVariantMap = {
  "size": [
    "default",
    "element",
    "fill"
  ]
}

const dropZoneVariantKeys = Object.keys(dropZoneVariantMap)

export const dropZone = /* @__PURE__ */ Object.assign(memo(dropZoneFn.recipeFn), {
  __recipe__: true,
  __name__: 'dropZone',
  __getCompoundVariantCss__: dropZoneFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: dropZoneVariantKeys,
  variantMap: dropZoneVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, dropZoneVariantKeys)
  },
  getVariantProps: dropZoneFn.getVariantProps,
})